export enum DocumentSetStatus {
  NOT_COMPLETE = 'DOCUMENTS_NOT_COMPLETE',
  COMPLETE = 'DOCUMENTS_COMPLETE',
  APPROVED = 'DOCUMENTS_APPROVED',
}
